import { render, staticRenderFns } from "./sellClue.vue?vue&type=template&id=228870ca&scoped=true"
import script from "./sellClue.vue?vue&type=script&lang=js"
export * from "./sellClue.vue?vue&type=script&lang=js"
import style0 from "./sellClue.vue?vue&type=style&index=0&id=228870ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228870ca",
  null
  
)

export default component.exports